<form [formGroup]="form" (ngSubmit)="onSubmit()" class="container mt-3">
    <fieldset>
        <legend>Product Information</legend>
        <dai-form-group for="product-sku" label="SKU" [controller]="form.controls['sku']">
            <input #inputRef id="product-sku" formControlName="sku" [readOnly]="!new" [disabled]="!new"
                [style]="{'background': new ? 'white' : 'lightgray' }" />
        </dai-form-group>

        <dai-form-group for="product-name" label="Name" [controller]="form.controls['name']">
            <input #inputRef id="product-name" formControlName="name" />
        </dai-form-group>

        <dai-form-group for="product-active" label="Active" [controller]="form.controls['active']">
            <input #inputRef id="product-active" type="checkbox" formControlName="active" />
        </dai-form-group>

        <dai-form-group for="product-moq" label="Minimum Order Quantity"
            [controller]="form.controls['minimumOrderQuantity']">
            <input #inputRef id="product-moq" type="number" min="1" step="1" formControlName="minimumOrderQuantity" />
        </dai-form-group>

        <dai-form-group for="product-description" label="Description" [controller]="form.controls['description']">
            <textarea #inputRef id="product-description" formControlName="description"></textarea>
        </dai-form-group>

        <dai-form-group for="product-memo" label="Memo" [controller]="form.controls['memo']">
            <textarea #inputRef id="product-memo" formControlName="memo"></textarea>
        </dai-form-group>

        <dai-form-group for="product-origin-code" label="Product Origin" [controller]="form.controls['originCode']">
            <select #inputRef id="product-origin-code" formControlName="originCode">
                @for(origin of originCodes; track origin.id)
                {
                <option value="{{origin.id}}">{{origin.description}} ({{origin.tariffSurchargeRate}}% Tariff)
                </option>
                }
            </select>
        </dai-form-group>

        <dai-form-group for="product-image" label="Product Image">
            <input type="file" id="product-image" accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                (change)="onFileSelected($event)" />
        </dai-form-group>
    </fieldset>

    @if(new) {
    <fieldset>
        <legend>Pricing Options</legend>
        <dai-form-group for="product-listprice" label="List Price" [controller]="form.controls['listPrice']">
            <dai-currency-input #inputRef formControlName="listPrice"></dai-currency-input>
        </dai-form-group>


        <dai-form-group for="product-dealerPrice" label="Dealer Price" [controller]="form.controls['dealerPrice']">
            <dai-currency-input #inputRef formControlName="dealerPrice"></dai-currency-input>
        </dai-form-group>

        <dai-form-group for="product-directPrice" label="Direct Price" [controller]="form.controls['directPrice']">
            <dai-currency-input #inputRef formControlName="directPrice"></dai-currency-input>
        </dai-form-group>
    </fieldset>
    }

    @if(additionalAttrKeys.length > 0)
    {
    <fieldset>
        <legend>Product Specific Attributes</legend>
        <!-- Dynamic Additional Attributes -->
        <div formGroupName="additionalAttributes">
            @for (key of additionalAttrKeys; track key)
            {
            <div [formGroupName]="key">
                @let attrControl = form.get(['additionalAttributes', key, 'value']);
                @let attrId = 'product' + key;
                @if (attrControl) {
                <dai-form-group [for]="attrId" [label]="form.get(['additionalAttributes', key, 'label'])?.value"
                    [controller]="attrControl">
                    <input #inputRef [id]="attrId" type="text" formControlName="value"
                        [ngbTypeahead]="searchFor(key)" />
                </dai-form-group>
                }
            </div>
            }
        </div>
    </fieldset>
    }

    <div class="row mb-5">
        <div class="offset-md-2 px-3">
            <button type="submit" class="btn btn-primary">Submit</button>
        </div>
    </div>
</form>